export default "__VITE_ASSET__j053jr2m__"